import { render, staticRenderFns } from "./PrayFor.vue?vue&type=template&id=39a1f2d4&scoped=true&"
import script from "./PrayFor.vue?vue&type=script&lang=ts&"
export * from "./PrayFor.vue?vue&type=script&lang=ts&"
import style0 from "./PrayFor.vue?vue&type=style&index=0&id=39a1f2d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a1f2d4",
  null
  
)

export default component.exports